import * as React from 'react';
import styled from 'styled-components';

declare module '../Controls/hkt' {
    interface URIControlsToKind {
        'radio': IRadioProps
    }
}

const Control = styled.input.attrs(_ => ({
    type: 'radio',
}))`
    appearance: none;
    width: 1.4em;
    height: 1.4em;
    border-radius: 50%;
    background-color: #e8ecef;
    border: 1px solid transparent;
    transition: all .33s ease-in-out;
    cursor: pointer;
    position: relative;
    margin: auto 0;

    &:not(:checked):hover {
        background-color: #E8ECEF;
    }

    &:checked:hover {
        background-color: #8794A3;
    }

    &:after {
        content: "";
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        width: .7em;
        height: .7em;
        transform: translate(-50%, -50%);
        opacity: 0;
        box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.25);
        background-color: #fff;
        border-radius: 50%;
    }

    &:checked {
        background-color: #B5C3D3;

        &:after {
            opacity: 1;
        }
    }

    &:checked:disabled {
        background-color: #C1CCD8;

        &:after {
            background-color: #E7EAEE;
        }
    }

    &:not(:checked):disabled {
        background: #F2F3F4;
    }
`;


type IRadioProps = {
    name: string,
    onChange: (x: string, name: string, e: React.MouseEvent<HTMLInputElement, MouseEvent>) => void,
    value: string,
    checked?: boolean,
    disabled?: boolean,
    className?: string,
}

const Radio = React.forwardRef<HTMLInputElement, IRadioProps>(({ 
    name, 
    onChange, 
    value,
    checked = false,
    disabled = false, 
    className,
}, ref) => {


    const selfChange = (e: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
        onChange(value, name, e);
    }

    return (
        <Control
            name={name}
            disabled={disabled}
            defaultChecked={checked}
            onClick={selfChange}
            value={value}
            ref={ref}
            className={className}
        />
    );
});

export default Radio;
